import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  arrow: {
    "&:before": {
      border: "1px solid #E6E8ED"
    },
    color: theme.palette.common.white
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    border: "1px solid #E6E8ED",
    color: "#4D4F5C" ,
    textTransform: "lowercase"
  }
}));

export default function ArrowToolTip({toolTipData}) {
  let classes = useStyles();

  return (
    <Tooltip
      title={toolTipData.text}
      arrow
      classes={{arrow: classes.arrow, tooltip: classes.tooltip}}
    >
      <span className={toolTipData.className}>{toolTipData.text}</span>
    </Tooltip>
  );
}
